import * as React from 'react';
import { connect } from 'react-redux';
import * as MenuConfig from '../../../../typings/menu';
import { StyledHeaderSection } from '../styles';
import HeaderLogo from '../Logo';
import HeaderButton from '../HeaderButton';
import ShareButton, { ShareOrigin } from '../../../Share/ShareButton';
import DriveItemListViewSwitcher from '../../../DriveItemList/Switcher';
import DriveItemListSearchButton from '../../../DriveItemList/Search/Button';
import { Api } from '../../../../typings/api';
import DriveItemDownloadButton from '../../../DriveItem/DownloadButton';
import DriveItemListSearchField from '../../../DriveItemList/Search/Field';
import { DriveItemListSearchFieldDisplayType } from '../../../DriveItemList/Search/Field/constants';
import Utils, { ScreenFormat } from '../../../../utils';
import { StoreState } from '../../../../reducers';
import { RouterParamsState } from '../../../SetRouteParams/reducer';
import { DriveItemListOrigin } from '../../../DriveItemListPage/constants';
import RoutesUtils from '../../../../utils/routes';
import { ActionButtonStyle } from '../../../../utils/driveItem';

export enum HeaderSectionPosition {
	Left = 'left',
	Center = 'center',
	Right = 'right'
}

interface HeaderSectionProps {
	position: HeaderSectionPosition;
	menuItems: MenuConfig.MenuItem[];
	driveItems?: Api.DriveFolderInfo[];
	routerParamsHistory: RouterParamsState[];
}

class HeaderSection extends React.Component<HeaderSectionProps, {}> {

	render() {
		const { menuItems } = this.props;

		return (
			<StyledHeaderSection position={this.props.position}>
				{menuItems ?
					menuItems.map(
						(menuItem, index) => <div key={index}>{this.getMenuItemElement(menuItem)}</div>
					) : null
				}
			</StyledHeaderSection>
		);
	}

	getMenuItemElement(menuItem: MenuConfig.MenuItem) {
		const { driveItems, routerParamsHistory } = this.props;
		const { origin, originParam } = routerParamsHistory[routerParamsHistory.length - 1].params;
		const screenFormat = Utils.getScreenFormat();
		let itemArgs;
		switch (menuItem.type) {
			case MenuConfig.MenuItemType.Home:
				itemArgs = {
					icon: 'iconset_home',
					label: 'messages.home',
					type: menuItem.type,
					target: RoutesUtils.getPathHome(),
				};
				break;
			case MenuConfig.MenuItemType.Gallery:
				itemArgs = {
					icon: 'iconset_image',
					label: 'messages.my_gallery',
					type: menuItem.type,
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, null),
				};
				break;
			case MenuConfig.MenuItemType.BurgerButton:
				itemArgs = {
					icon: 'iconset_menu',
					label: 'messages.menu',
					type: menuItem.type,
				};
				break;
			case MenuConfig.MenuItemType.Logo:
				return <HeaderLogo />;
			case MenuConfig.MenuItemType.DownloadButton:
				return <DriveItemDownloadButton driveItems={driveItems ? driveItems : []} style={ActionButtonStyle.Icon} />;
			case MenuConfig.MenuItemType.ShareButton:
				return <ShareButton driveItems={driveItems ? driveItems : []} shareOrigin={ShareOrigin.Favorites} />;
			case MenuConfig.MenuItemType.SearchButton:
				if (screenFormat === ScreenFormat.Desktop) {
					return (
						<DriveItemListSearchField
							searchText={origin === DriveItemListOrigin.Search ? originParam : ''}
							displayType={DriveItemListSearchFieldDisplayType.Desktop}
						/>);
				} else {
					return <DriveItemListSearchButton />;
				}
			case MenuConfig.MenuItemType.DisplayButtons:
				return <DriveItemListViewSwitcher />;
			case MenuConfig.MenuItemType.Favorites:
				itemArgs = {
					label: 'messages.favorites',
					icon: 'iconset_favorite',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Favorites, null)
				};
				break;
			case MenuConfig.MenuItemType.New:
				itemArgs = {
					icon: 'iconset_news',
					label: 'messages.new',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.New, null),
				};
				break;
			case MenuConfig.MenuItemType.Updates:
				itemArgs = {
					label: 'messages.updates',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Updates, null),
				};
				break;
			case MenuConfig.MenuItemType.Downloads:
				itemArgs = {
					label: 'messages.downloads',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Downloads, null),
				};
				break;
			case MenuConfig.MenuItemType.Parameters:
				itemArgs = {
					icon: 'iconset_parameters',
					label: 'messages.parameters',
					target: RoutesUtils.getPathParameters(),
				};
				break;
			case MenuConfig.MenuItemType.Link:
				itemArgs = {
					type: MenuConfig.MenuItemType.Link,
					label: menuItem.label ? menuItem.label : 'Link',
					icon: menuItem.icon ? menuItem.icon : 'iconset_link',
					target: menuItem.target
				};
				break;
			case MenuConfig.MenuItemType.Asset:
				itemArgs = {
					type: MenuConfig.MenuItemType.Asset,
					label: menuItem.label ? menuItem.label : 'Asset',
					icon: menuItem.icon ? menuItem.icon : 'iconset_file',
					target: menuItem.target
				};
				break;
			case MenuConfig.MenuItemType.Folder:
				itemArgs = {
					type: MenuConfig.MenuItemType.Folder,
					label: menuItem.label ? menuItem.label : 'Folder',
					icon: menuItem.icon ? menuItem.icon : 'iconset_folder',
					target: menuItem.target
				};
				break;
			case MenuConfig.MenuItemType.Page:
				itemArgs = {
					type: MenuConfig.MenuItemType.Page,
					label: menuItem.label ? menuItem.label : 'Page',
					icon: menuItem.icon ? menuItem.icon : 'iconset_page',
					target: menuItem.target,
				};
				break;
		}
		return (
			<HeaderButton
				label={itemArgs.label}
				icon={itemArgs.icon}
				type={itemArgs.type}
				target={itemArgs.target}
			/>);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { routerParamsHistory } = state;
	return { routerParamsHistory };
};

export default connect(mapStateToProps)(HeaderSection);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/Section/index.tsx